<template>
  <div id="record">
    <div class="rightContent">
      <div style="text-align:right;" class="tableheader">
        <button @click="delRecord(-1)" type="button" size="small" class="btn1 el-button btndel" style="float:left;">
          <span>{{ $t("delete_select") }}</span>
        </button>
        <el-select @change="getList" v-model="child" :placeholder="$i18n.t('record_list').select" size="mini"
          style="float:left;margin-left:5px;width:100px;margin-top:5px;">
          <el-option :label="$i18n.t('record_list').all" value=""></el-option>
          <el-option :label="$i18n.t('record_list').my" value="-10"></el-option>
          <el-option v-for="(item, index) in children" :key="index" :label="item.user_acct"
            :value="item.user_id"></el-option>
        </el-select>

        <button v-if="record_expprt" @click="expRecord('record_expprt')" type="button" size="small"
          class="btn1 el-button btndel" style="margin-right: 10px;">
          <span>{{ $t('record_expprt') }}</span>
        </button>
        <button v-if="customer_expprt" @click="expRecord('customer_expprt')" type="button" size="small"
          class="btn1 el-button btndel" style="margin-right: 10px;">
          <span>{{ $t('customer_expprt') }}</span>
        </button>

        <el-cascader @change="getList" v-if="is_ban" v-model="weidu" :options="wdOptions" :props="wdProps" size="mini"
          style="width:100px;margin-top:5px;margin-right: 10px;" clearable></el-cascader>

        <!-- <el-select @change="getList" v-model="weidu" :placeholder="$i18n.t('record_list').select" size="mini" style="width:100px;margin-top:5px;margin-right: 10px;">
		  <el-option v-for="(item,index) in selectWeidus" :key="index" :label="item" :value="index"></el-option>
		</el-select>
		<el-select @change="getList" v-model="level" :placeholder="$i18n.t('record_list').select" size="mini" style="width:100px;margin-top:5px;margin-right: 10px;">
		  <el-option v-for="(item,index) in selectLevels" :key="index" :label="item" :value="index"></el-option>
		</el-select> -->

        <el-date-picker size="small" style="top:2px;" @change="getList" v-model="dateValue" value-format="yyyy-MM-dd"
          type="daterange" :range-separator="$i18n.t('to')" :start-placeholder="$i18n.t('start_time')"
          :end-placeholder="$i18n.t('end_time')"></el-date-picker>
        <el-input style="width:1.5rem;margin-left:0.1rem;" size="small" v-model="q"
          :placeholder="$i18n.t('record_search_key')"></el-input>
        <button @click="getList" type="button" size="small" class="btn1 el-button btndel">
          <span>{{ $t("search") }}</span>
        </button>
      </div>

      <div class="listBlock">
        <el-table ref="recordTable" height="850" :data="lists" :fit="false" style="width: 100%;" row-key="id" @selection-change="handleSelectionChange">
          <el-table-column fixed type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column :label="$i18n.t('test_img')" width="110">
            <template slot-scope="scope">
              <img :src="scope.row.image + '_20x20.jpg'" width="80" height="80" />
            </template>
          </el-table-column>
          <el-table-column :label="$i18n.t('customer_mess')" width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.customer_nickname || scope.row.customer_mobile">
                <span>{{ scope.row.customer_nickname }} {{ scope.row.customer_mobile }}</span>
                <br />
                <span style="color: rgb(64, 158, 255);" @click="showCustomer(scope.row)">{{ $t("scan_mess") }}</span>
              </div>
              <div v-else>{{ $t("nothave") }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$i18n.t('record_list').sex" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.customer_sex == 1">{{ $t('record_list').male }}</span>
              <span v-else>{{ $t('record_list').female }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$i18n.t('mess_question')" width="120">
              <template slot-scope="scope">
                <span
                  style="color: rgb(64, 158, 255);"
                  v-if="scope.row.question"
                  @click="showQuestion(scope.row.analysis)"
                >{{$t("check_question")}}</span>
                <span v-else>{{$t("nothave")}}</span>
              </template>
            </el-table-column> -->
          <el-table-column prop="code" :label="$i18n.t('sell_liss_vail_4')" width="110"></el-table-column>
          <el-table-column prop="user_acct" :label="$i18n.t('who')" width="150"></el-table-column>
          <el-table-column :label="$i18n.t('test_time')" width="180">
            <template slot-scope="scope">
              {{ dateFormatToLocal(scope.row.crt_time) }}
            </template>
          </el-table-column>
          <el-table-column :label="$i18n.t('test_status')" width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 2">{{ $t("normal_success") }}</span>
              <span v-if="scope.row.status != 2">{{ scope.row.reason }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$i18n.t('mark')" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.mark">
                {{ scope.row.mark }}
                <a style="color:#409EFF" href="#"
                  @click="setMark(scope.row.id, scope.row.mark)">{{ $t("normal_edit") }}</a>
              </span>
              <a style="color:#409EFF" href="#" @click="setMark(scope.row.id, '')" v-else>{{ $t("add_mark") }}</a>
            </template>
          </el-table-column>
          <el-table-column v-if="shouldShowAuditFeatures()" :label="$i18n.t('record_list').audit_status" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.countdown_checked && scope.row.countdown_checked.checked_status == 0">{{ $t("status_waite") }}</span>
              <span v-else-if="scope.row.countdown_checked && scope.row.countdown_checked.checked_status == 1">{{ $t("sell_liss_status_3") }}</span>
              <span v-else-if="scope.row.countdown_checked && scope.row.countdown_checked.checked_status == 2">{{ $t("status_refuse") }}</span>
              <span v-else>{{ $t("nothave") }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="shouldShowAuditFeatures()" :label="$i18n.t('record_list').countdown_status" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.countdown_checked && scope.row.countdown_checked.count_down_status == 0">{{ $i18n.t('record_list').countdown_running }}</span>
              <span v-else-if="scope.row.countdown_checked && scope.row.countdown_checked.count_down_status == 1">{{ $i18n.t('record_list').countdown_ended }}</span>
              <span v-else>{{ $t("nothave") }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="shouldShowAuditFeatures()" :label="$i18n.t('record_list').countdown_end_time" width="240">
            <template slot-scope="scope">
              <span v-if="scope.row.countdown_checked && scope.row.countdown_checked.analysis_close_time">{{ dateFormatToLocal(scope.row.countdown_checked.analysis_close_time) }}</span>
              <span v-else>{{ $t("nothave") }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="platform === 'leshen'" :label="$i18n.t('record_list').comprehensive_overview" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.analysis && scope.row.analysis.final_result && scope.row.analysis.final_result.suggestion && scope.row.analysis.final_result.suggestion.introduction">{{ scope.row.analysis.final_result.suggestion.introduction }}</span>
              <span v-else>{{ $t("nothave") }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="platform === 'leshen'" :label="$i18n.t('record_list').skincare_overview" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.analysis && scope.row.analysis.final_result && scope.row.analysis.final_result.suggestion && scope.row.analysis.final_result.suggestion.skin_introduction">{{ scope.row.analysis.final_result.suggestion.skin_introduction }}</span>
              <span v-else>{{ $t("nothave") }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="platform === 'leshen'" :label="$i18n.t('record_list').skincare_advice" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.analysis && scope.row.analysis.final_result && scope.row.analysis.final_result.suggestion && scope.row.analysis.final_result.suggestion.skin_tips">{{ scope.row.analysis.final_result.suggestion.skin_tips }}</span>
              <span v-else>{{ $t("nothave") }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="platform === 'leshen'" :label="$i18n.t('record_list').precautions" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.analysis && scope.row.analysis.final_result && scope.row.analysis.final_result.suggestion && scope.row.analysis.final_result.suggestion.tips">{{ scope.row.analysis.final_result.suggestion.tips }}</span>
              <span v-else>{{ $t("nothave") }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$i18n.t('contral')" fixed="right" width="220">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="small" @click="setIframeUrl(scope.row.result_id)">{{ $t("scan_detail") }}</el-button>
                <el-button type="text" size="small" @click="delRecord(scope.row.id)">{{ $t("delete") }}</el-button>
                <el-button type="text" size="small" @click="exportImgs(scope.row.analysis)">{{ $t("records.export_img") }}</el-button>
              </div>
              <div v-if="platform === 'leshen' || shouldShowAuditFeatures(scope.row)">
                <el-button v-if="platform === 'leshen'" type="text" size="small" @click="editRecord(scope.row)">{{ $t("edit") }}</el-button>
                <template v-if="shouldShowAuditFeatures(scope.row)">
                  <el-button type="text" size="small" @click="auditRecord(scope.row)">{{ $t("check") }}</el-button>
                  <el-button type="text" size="small" @click="setCountdown(scope.row)">{{ $t("record_list").countdown_setting }}</el-button>
                </template>
              </div>
              <div v-if="platform === 'leshen'">
                <el-button type="text" size="small" @click="recommendGoods(scope.row)">{{ $i18n.t('record_list').recommend_goods }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="showFlow" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="page" :page-sizes="[10, 20, 50, 100, 200]" :page-size="pageSize"
          layout="sizes,total, prev, pager, next" :total="total"></el-pagination>
        <el-dialog :title="$i18n.t('scan_detail')" :visible.sync="dialogTableVisible" width="690px">
          <iframe ref="layer" style="border:none;"
            :src="'/zmskinweb/#/layer?shareId=' + now_result_id + '&locale=' + (locale == 'id' ? 'in' : locale)" width="650"
            height="800px" id="id1"></iframe>
          <!-- <el-tabs style="overflow: hidden;" v-model="dialogActiveName" @tab-click="tabHandleClick" >
            <el-tab-pane :label="$i18n.t('record_detail_layer')" name="layer" >
              <iframe
                      ref="layer"
                      style="border:none;"
                      :src="'/zmskinweb/#/layer?shareId='+now_result_id+'&locale='+locale"
                      width="650"
                      height="800px"
                      id="id1"
              ></iframe>
              <button  @click="reportPrint('id1')" type="button" size="small" class="btn1 el-button btnPrint" >
                <span>{{$t("records.print_select")}}</span>
              </button>
            </el-tab-pane>
            <el-tab-pane :label="$i18n.t('record_detail_deep')" name="deep">
              <iframe
                      ref="deep"
                      style="border:none;"
                      :src="'/zmskinweb/#/deep?shareId='+now_result_id+'&locale='+locale"
                      width="650"
                      height="800px"
                      id="id2"
              ></iframe>
              <button  @click="reportPrint('id2')" type="button" size="small" class="btn1 el-button btnPrint" >
                <span>{{$t("records.print_select")}}</span>
              </button>
            </el-tab-pane>
            <el-tab-pane :label="$i18n.t('record_detail_report')" name="report">
              <iframe
                      ref="report"
                      style="border:none;"
                      :src="'/zmskinweb/#/report?shareId='+now_result_id+'&locale='+locale"
                      width="650"
                      height="800px"
                      id="id3"
              ></iframe>
              <button  @click="reportPrint('id3')" type="button" size="small" class="btn1 el-button btnPrint" >
                <span>{{$t("records.print_select")}}</span>
              </button>
            </el-tab-pane>
          </el-tabs> -->
        </el-dialog>
        <el-dialog :title="$i18n.t('delete_status')" :visible.sync="dialogDELVisible" width="30%">
          <span>{{ $t("record_delete_tips") }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogDELVisible = false">{{ $t("normal_cancle") }}</el-button>
            <el-button type="primary" @click="sureDel">{{ $t("normal_sure") }}</el-button>
          </span>
        </el-dialog>
        <el-dialog class="mark" :title="$i18n.t('mark')" :visible.sync="dialogMarkDELVisible">
          <el-input rows="4" type="textarea" v-model="markcontent"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogMarkDELVisible = false">{{ $t("normal_cancle") }}</el-button>
            <el-button type="primary" @click="saveMark">{{ $t("normal_sure") }}</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="$i18n.t('customer_mess')" width="30%" style="margin-top:100px;"
          :visible.sync="dialogCustomerShow">
          <el-form>
            <el-form-item :label="$i18n.t('support_username')" :label-width="formLabelWidth">
              <el-input v-model="customer.nickname" disabled="disabled" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$i18n.t('support_mobile')" :label-width="formLabelWidth">
              <el-input v-model="customer.mobile" disabled="disabled" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$i18n.t('sex_name')" :label-width="formLabelWidth">
              <el-radio v-model="customer.sex" label="1">{{ $t("sex")[0] }}</el-radio>
              <el-radio v-model="customer.sex" label="2">{{ $t("sex")[1] }}</el-radio>
            </el-form-item>
            <el-form-item :label="$i18n.t('age_name')" :label-width="formLabelWidth">
              <el-input v-model="customer.age" disabled="disabled" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$i18n.t('location_name')" :label-width="formLabelWidth">
              <el-input v-model="customer.location" disabled="disabled" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$i18n.t('level_name')" :label-width="formLabelWidth">
              <el-input v-model="customer.level" disabled="disabled" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$i18n.t('support_introducer')" :label-width="formLabelWidth">
              <el-input v-model="customer.introducer" disabled="disabled" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$i18n.t('support_comments')" :label-width="formLabelWidth">
              <el-input v-model="customer.comments" disabled="disabled" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </el-dialog>
        <el-dialog :title="$i18n.t('check_question')" width="60%" :visible.sync="dialogQuestionShow">
          <div v-for="(item, index) in list" :key="index">
            <div class="question">
              <div class="title">{{ index + 1 }}. {{ item.question }}</div>
              <input v-if="item.type == 3" type="text" v-model="answers[item.id]" value :placeholder="item.placeholder"
                class="input-text" />
              <ol v-else>
                <li :class="{ check1: item.type == 1, check2: item.type == 2 }" v-for="(option, opIndex) in item.options"
                  :key="opIndex">
                  <label>
                    <span :class="{ choose: answers[item.id] && answers[item.id].indexOf(option.id) > -1 }">
                      <i></i>
                    </span>
                    <p>{{ option.option }}</p>
                  </label>
                </li>
              </ol>
            </div>
            <div class="line" v-if="index < list.length - 1"></div>
          </div>
        </el-dialog>
        <el-dialog :title="$t('check')" :visible.sync="dialogAuditVisible" width="30%">
          <el-form>
            <el-form-item :label="$i18n.t('record_list').audit_status" :label-width="formLabelWidth">
              <el-radio v-model="auditStatus" :label="1">{{ $t("sell_liss_status_3") }}</el-radio>
              <el-radio v-model="auditStatus" :label="2">{{ $t("status_refuse") }}</el-radio>
            </el-form-item>
            <el-form-item :label="$i18n.t('mark')" :label-width="formLabelWidth">
              <el-input rows="3" type="textarea" v-model="auditRemark" :placeholder="$i18n.t('record_list').audit_remark || ''"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogAuditVisible = false">{{ $t("normal_cancle") }}</el-button>
            <el-button type="primary" @click="saveAudit">{{ $t("normal_sure") }}</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="$i18n.t('record_list').countdown_setting" :visible.sync="dialogCountdownVisible" width="30%">
          <el-form label-position="top">
            <el-form-item :label="$i18n.t('record_list').countdown_end_time">
              <el-date-picker
                v-model="countdownEndTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$i18n.t('record_list').select_countdown_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogCountdownVisible = false">{{ $t("normal_cancle") }}</el-button>
            <el-button type="primary" @click="extendCountdown">{{ $i18n.t('record_list').extend_countdown }}</el-button>
            <el-button type="danger" @click="stopCountdown">{{ $i18n.t('record_list').stop_countdown }}</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="$t('edit')" :visible.sync="dialogEditVisible" width="50%">
          <el-form label-position="top">
            <el-form-item :label="$i18n.t('record_list').comprehensive_overview">
              <el-input
                type="textarea"
                :rows="4"
                v-model="editForm.introduction"
                :placeholder="$i18n.t('record_list').comprehensive_overview"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$i18n.t('record_list').skincare_overview">
              <el-input
                type="textarea"
                :rows="4"
                v-model="editForm.skin_introduction"
                :placeholder="$i18n.t('record_list').skincare_overview"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$i18n.t('record_list').skincare_advice">
              <el-input
                type="textarea"
                :rows="4"
                v-model="editForm.skin_tips"
                :placeholder="$i18n.t('record_list').skincare_advice"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$i18n.t('record_list').precautions">
              <el-input
                type="textarea"
                :rows="4"
                v-model="editForm.tips"
                :placeholder="$i18n.t('record_list').precautions"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogEditVisible = false">{{ $t("normal_cancle") }}</el-button>
            <el-button type="primary" @click="saveEdit">{{ $t("normal_sure") }}</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="$i18n.t('record_list').recommend_goods" :visible.sync="dialogRecommendGoodsVisible" width="70%">
          <el-form label-position="top">
            <el-form-item :label="$i18n.t('record_list').signature_image">
              <el-upload
                class="avatar-uploader"
                action="/fileSvr/put"
                name="name"
                :data="{ app_name: 'conf_app' }"
                :show-file-list="false"
                :on-success="handleSignatureImageSuccess"
                :before-upload="beforeSignatureImageUpload"
              >
                <img v-if="recommendGoodsForm.push_sign_pic" :src="managerImg(recommendGoodsForm.push_sign_pic)" class="avatar" style="max-width: 200px; max-height: 200px;" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item :label="$i18n.t('record_list').current_recommended_goods">
              <div v-if="recommendGoodsList.length === 0" style="color: #999;">{{ $t("nothave") }}</div>
              <div v-else style="display: flex; flex-wrap: wrap; gap: 15px;">
                <div v-for="(goods, index) in recommendGoodsList" :key="goods.goods_id || index" style="border: 1px solid #ddd; padding: 10px; border-radius: 4px; width: 130px;">
                  <img v-if="goods.goods_pic" :src="managerImg(goods.goods_pic)" style="width: 100%; height: 120px; object-fit: cover; border-radius: 4px;" />
                  <div style="margin-top: 8px; text-align: center; font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ goods.goods_name }}</div>
                  <el-button type="danger" size="mini" style="width: 100%; margin-top: 8px;" @click="removeRecommendedGoods(index)">{{ $t("delete") }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$i18n.t('record_list').add_goods">
              <el-select
                v-model="selectedGoodsId"
                :placeholder="$i18n.t('record_list').select_goods"
                filterable
                style="width: 100%;"
                @change="addGoods"
              >
                <el-option
                  v-for="goods in allGoodsList"
                  :key="goods.id"
                  :label="goods.goods_name"
                  :value="goods.id"
                  :disabled="isGoodsSelected(goods.id)"
                >
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <img v-if="goods.goods_pic" :src="managerImg(goods.goods_pic)" style="width: 30px; height: 30px; object-fit: cover; border-radius: 2px; flex-shrink: 0;" />
                    <span>{{ goods.goods_name }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogRecommendGoodsVisible = false">{{ $t("normal_cancle") }}</el-button>
            <el-button type="primary" @click="saveRecommendGoods">{{ $t("normal_sure") }}</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "record",
  data() {
    return {
      platform: '',
      doing: false,
      doing1: false,
      code: "-1",
      lists: [],
      children: null,
      child: "",
      deviceLists: null,
      modelType: '1',
      showFlow: false,
      pageSize: 10,
      page: 1,
      total: 100,
      now_result_id: "",
      dialogTableVisible: false,
      dateValue: "",
      multipleSelection: [],
      dialogDELVisible: false,
      dialogMarkDELVisible: false,
      markcontent: "",
      mark_analysis_id: "",
      ids: [],
      host: "",
      q: "",
      formLabelWidth: "100px",
      dialogCustomerShow: false,
      customer: {
        nickname: "",
        mobile: "",
        sex: "0",
        age: "",
        location: "",
        level: ''
      },
      dialogQuestionShow: false,
      dialogActiveName: 'layer',
      answers: {},
      list: [],
      dialogAuditVisible: false,
      auditRecordId: '',
      auditStatus: 1,
      auditRemark: '',
      dialogCountdownVisible: false,
      countdownRecordId: '',
      countdownEndTime: '',
      countdownRow: null,
      dialogEditVisible: false,
      editForm: {
        result_id: '',
        introduction: '',
        skin_introduction: '',
        skin_tips: '',
        tips: ''
      },
      dialogRecommendGoodsVisible: false,
      recommendGoodsForm: {
        result_id: '',
        push_sign_pic: '',
        push_goods: ''
      },
      recommendGoodsList: [],
      allGoodsList: [],
      selectedGoodsId: null,
      defualtHost: '',
      userHost: '',
      needReloadTabs: {
        layer: false,
        deep: false,
        report: false
      },
      locale: '',
      selectWeidus: this.$i18n.t('record_list').weidu,
      selectLevels: this.$i18n.t('record_list').level,
      weidu: 'all',
      record_expprt: false,
      customer_expprt: false,
      is_ban: false,
      wdProps: { multiple: true },
      wdOptions: [],
      reportCountdown: false
    };
  },
  computed: {},
  created() {
    this.locale = localStorage.locale;
    let url = window.location.href;
    this.host = "https://test.yimei.ai";
    if (url.indexOf("mirror") > 0) {
      this.host = "https://mirror.yimei.ai";
    }
    this.resizedwindow()
    this.initWddata()
    this.initConf()
    this.getList()
    let userConfs = JSON.parse(localStorage.userConfs)
    this.platform = userConfs.platform
  },
  methods: {
    initWddata() {
      this.wdOptions = []
      let wdlevel = []
      for (let j in this.selectLevels) {
        let it = {
          value: j,
          label: this.selectLevels[j]
        }
        wdlevel.push(it)
      }
      for (let i in this.selectWeidus) {
        let item = {
          value: i,
          label: this.selectWeidus[i],
          children: wdlevel
        }
        this.wdOptions.push(item)
      }

      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() + 1;
      var day = today.getDate();
      month = (month < 10) ? '0' + month : month;
      day = (day < 10) ? '0' + day : day;
      var ft = year + '-' + month + '-' + '01';
      var td = year + '-' + month + '-' + day;
      this.dateValue = [ft, td]
    },
    initConf() {
      let userConfs = JSON.parse(localStorage.userConfs)
      //localStorage.userConfs = JSON.stringify(response.data);
      if (userConfs.code === 0) {
        if (userConfs.record_expprt) {
          this.record_expprt = true
        }
        if (userConfs.customer_expprt) {
          this.customer_expprt = true
        }
        if (userConfs.platform && userConfs.platform == 'ban') {
          this.is_ban = true
        }
      }

      // let _this = this
      // let data = {code: 'record_expprt,customer_expprt,platform'}
      // this.axios
      //     .post("/skinMgrSrv/config/get", this.formData(data))
      //     .then(function(response) {
      //         if (response.data.code === 0) {
      // 		if(response.data.record_expprt) {
      // 			_this.record_expprt = true
      // 		}
      // 		if(response.data.customer_expprt) {
      // 			_this.customer_expprt = true
      // 		}
      // 		if(response.data.platform && response.data.platform == 'ban') {
      // 			_this.is_ban = true
      // 		}
      //         }
      //     }).catch(function (res) {
      //     console.error(res)
      // });
    },
    expRecord(code) {
      let st = ''
      let ed = ''
      if (this.dateValue && this.dateValue[0]) {
        st = this.dateValue[0]
      }
      if (this.dateValue && this.dateValue[1]) {
        ed = this.dateValue[1]
      }
      window.open('/skinMgrSrv/record/exportdt?code=' + code + '&st=' + st + '&ed=' + ed, '_self')
    },
    tabHandleClick(tab, event) {
      if (this.needReloadTabs[tab.name] == true) {
        this.$refs[tab.name].contentWindow.location.reload();
        this.$set(this.needReloadTabs, tab.name, false);
      }
    },
    reportPrint(id) {
      document.getElementById(id).contentWindow.print();
    },
    showCustomer(
      data
    ) {
      this.dialogCustomerShow = true;
      this.customer = {
        nickname: data.customer_nickname,
        mobile: data.customer_mobile,
        sex: data.customer_sex + '',
        age: data.customer_age,
        comments: data.customer_comments,
        introducer: data.customer_introducer,
        location: data.customer_location,
        level: data.customer_level
      };
    },
    showQuestion(item) {
      var analysis = JSON.parse(item)
      if (analysis.other_detects && analysis.other_detects.questions) {
        this.answers = analysis.other_detects.questions;
        this.dialogQuestionShow = true;
      }
    },
    loadQuestions() {
      var _this = this;
      this.axios.get("/skinMgrSrv/question/list")
        .then(function (res) {
          if (res.data.code == 0) {
            _this.list = res.data.list;
          }
        })
    },
    handleSelectionChange(val) {
      this.ids = [];
      if (val) {
        for (let i in val) {
          if (val[i].id) {
            this.ids.push(val[i].id);
          }
        }
      }
      console.log(this.ids);
    },
    setMark(id, mark) {
      this.mark_analysis_id = id;
      this.markcontent = mark;
      this.dialogMarkDELVisible = true;
    },
    saveMark() {
      if (this.doing1 === true) {
        return false;
      }
      this.doing1 = true;
      let _this = this;
      let data = { analysis_id: this.mark_analysis_id, mark: this.markcontent };
      this.axios
        .post("/skinMgrSrv/record/mark", this.formData(data))
        .then(function (response) {
          _this.doing1 = false;
          if (response.data.code === 0) {
            _this.getList();
          }
          _this.dialogMarkDELVisible = false;
        }).catch(function (res) {
          _this.doing1 = false
        });
    },
    exportImgs(analysis) {
      let light = this.$i18n.t("record_list").light
      let keys = {
        filename: light[0], filename_positive: light[1], filename_negative: light[2], filename_uv: 'uv', filename_woods: light[3],
        filename_blue: light[4], filename_brown: light[5], filename_red: light[6]
      };
      let t = new Date().getTime()
      for (var k in keys) {
        this.downloadImg(analysis[k], t + '-' + keys[k] + '.jpeg')
      }
    },
    downloadImg(url, name) {
      url = url.replace(this.getBaseUrl(url), this.getBaseUrl(window.location.href)) + '_40x40.jpg'

      var image = new Image()
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var imgUrl = canvas.toDataURL('image/jpeg', 0.96)
        var userAgent = navigator.userAgent;
        var isOpera = userAgent.indexOf("Opera") > -1;
        if (userAgent.indexOf("Trident") > -1 || (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera)) {
          //Edge ,IE
          var oPop = window.open(imgUrl, "", "width=1, height=1, top=5000, left=5000");
          for (; oPop.document.readyState != "complete";) {
            if (oPop.document.readyState == "complete") break;
          }
          oPop.document.execCommand("SaveAs");
          oPop.close();
        } else {
          var a = document.createElement('a')
          var event = new MouseEvent('click')
          a.download = name
          a.href = url
          a.dispatchEvent(event)
        }
      }
      image.src = url
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      if (this.code === "") {
        return false;
      }
      console.log('this.weidu', this.weidu)
      let dataLoadIng = this.openFullScreen();
      //this.doing = true;
      let _this = this;
      let data = {
        code: this.code,
        page: this.page,
        pageSize: this.pageSize
      };
      if (this.dateValue && this.dateValue.length > 0) {
        data.st = this.dateFormatToLocal(this.dateValue[0]+' 00:00:00')
        data.ed = this.dateFormatToLocal(this.dateValue[1]+' 23:59:59') 
      }
      if (this.q) {
        data.q = this.q
      }
      if (this.child) {
        data.child = this.child
      }
      if (this.weidu) {
        data.weidu = this.weidu
      }
      console.log(data);
      this.axios
        .post("/skinMgrSrv/record/list", this.formData(data))
        .then(function (response) {
          if (response.data.code === 0) {
            const totalValue = parseInt(response.data.data.total);
            _this.total = isNaN(totalValue) ? 0 : totalValue;
            _this.showFlow = true;
            _this.lists = response.data.data.list;
            _this.children = response.data.data.child;
            _this.defualtHost = response.data.default_host;
            _this.userHost = response.data.user_host;
            _this.reportCountdown = response.data.reportCountdown !== false;
            _this.$nextTick(() => {
              if (_this.$refs.recordTable) {
                _this.$refs.recordTable.doLayout();
              }
            });
          } else {
            _this.lists = []
            _this.total = 0
            _this.showFlow = false
            _this.$message(response.data.msg)
          }
          setTimeout(() => {
            dataLoadIng.close();
          }, 600);
        }).catch(function (res) {
          console.log(res)
          _this.lists = []
          _this.total = 0
          _this.showFlow = false
          setTimeout(() => {
            dataLoadIng.close();
          }, 600);
        });
    },
    setIframeUrl(id) {
      this.now_result_id = id;
      this.dialogTableVisible = true;
      setTimeout(() => {
        let needReload = {
          layer: true,
          deep: true,
          report: true
        }
        needReload[this.dialogActiveName] = false
        this.needReloadTabs = needReload
        this.$refs[this.dialogActiveName].contentWindow.location.reload();
      }, 100);
    },
    delRecord(id) {
      if (id === -1) {
        if (this.ids.length < 1) {
          this.$message(this.$i18n.t('check_question'));
          return false;
        }
      } else {
        this.ids = [];
        this.ids.push(id);
      }
      this.dialogDELVisible = true;
    },
    sureDel() {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {
        code: this.code,
        ids: this.ids
      };
      this.axios
        .post("/skinMgrSrv/record/del", this.formData(data))
        .then(function (response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t("deletesuccess"));
            _this.getList();
            _this.dialogDELVisible = false;
          }
        }).catch(function (res) {
          _this.doing = false;
        });
    },
    editRecord(row) {
      console.log('editRecord called', row);
      // 初始化编辑表单数据
      this.editForm.result_id = row.result_id;
      const suggestion = row.analysis && row.analysis.final_result && row.analysis.final_result.suggestion;
      this.editForm.introduction = (suggestion && suggestion.introduction) || '';
      this.editForm.skin_introduction = (suggestion && suggestion.skin_introduction) || '';
      this.editForm.skin_tips = (suggestion && suggestion.skin_tips) || '';
      this.editForm.tips = (suggestion && suggestion.tips) || '';
      console.log('editForm', this.editForm);
      this.dialogEditVisible = true;
    },
    recommendGoods(row) {
      this.recommendGoodsForm.result_id = row.result_id;
      // 初始化推荐商品列表
      const goods = row.analysis && row.analysis.final_result && row.analysis.final_result.goods;
      this.recommendGoodsList = goods ? (Array.isArray(goods) ? goods : []) : [];
      // 初始化签名图片
      this.recommendGoodsForm.push_sign_pic = '';
      this.selectedGoodsId = null;
      // 获取所有商品列表
      this.getAllGoodsList();
      this.dialogRecommendGoodsVisible = true;
    },
    getAllGoodsList() {
      let _this = this;
      // 参考 goods/list.vue 的实现，接口直接返回 list、total 等在 data 根上
      const data = {
        q: '',
        page: 1,
        pageSize: 200
      };
      this.axios
        .post("/skinMgrSrv/goods/list", this.formData(data))
        .then(function (response) {
          if (response.data && response.data.code === 0) {
            _this.allGoodsList = response.data.list || [];
          } else {
            _this.allGoodsList = [];
          }
        }).catch(function (res) {
          console.log(res);
          _this.allGoodsList = [];
        });
    },
    isGoodsSelected(goodsId) {
      return this.recommendGoodsList.some(goods => goods.goods_id === goodsId || goods.id === goodsId);
    },
    addGoods(goodsId) {
      if (!goodsId) return;
      const goods = this.allGoodsList.find(g => g.id === goodsId);
      if (goods && !this.isGoodsSelected(goodsId)) {
        this.recommendGoodsList.push({
          goods_id: goods.id,
          id: goods.id,
          goods_name: goods.goods_name,
          goods_pic: goods.goods_pic
        });
        this.selectedGoodsId = null;
      }
    },
    removeRecommendedGoods(index) {
      this.recommendGoodsList.splice(index, 1);
    },
    handleSignatureImageSuccess(response, file) {
      if (response) {
        // 根据实际接口返回的字段名调整
        this.recommendGoodsForm.push_sign_pic = response.img_path || response.imgUrl || response.path || '';
      }
    },
    beforeSignatureImageUpload(file) {
      const isImage = file.type.indexOf('image') !== -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error(this.$i18n.t('imagelimit2m'));
        return false;
      }
      if (!isLt2M) {
        this.$message.error(this.$i18n.t('imagelimit2big'));
        return false;
      }
      return true;
    },
    managerImg(imgPath) {
      if (!imgPath) return '';
      if (imgPath.indexOf('http') !== -1) {
        return imgPath;
      }
      return '/fileSvr/get/' + imgPath;
    },
    saveRecommendGoods() {
      // 验证商品数量
      if (this.recommendGoodsList.length < 3) {
        this.$message.error(this.$i18n.t('record_list').goods_count_min_error);
        return false;
      }
      if (this.recommendGoodsList.length > 8) {
        this.$message.error(this.$i18n.t('record_list').goods_count_max_error);
        return false;
      }
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      // 构建 push_goods 字符串（goods_id 用逗号分隔）
      const goodsIds = this.recommendGoodsList.map(goods => goods.goods_id || goods.id).join(',');
      let data = {
        result_id: this.recommendGoodsForm.result_id,
        push_sign_pic: this.recommendGoodsForm.push_sign_pic,
        push_goods: goodsIds
      };
      this.axios
        .post("/skinMgrSrv/savePushGoodsEdit", this.formData(data))
        .then(function (response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t("editsuccess"));
            _this.getList();
            _this.dialogRecommendGoodsVisible = false;
          } else {
            _this.$message(response.data.msg || _this.$i18n.t("editsfail"));
          }
        }).catch(function (res) {
          _this.doing = false;
          console.log(res);
          _this.$message(_this.$i18n.t("editsfail"));
        });
    },
    saveEdit() {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {
        result_id: this.editForm.result_id,
        introduction: this.editForm.introduction,
        skin_introduction: this.editForm.skin_introduction,
        skin_tips: this.editForm.skin_tips,
        tips: this.editForm.tips
      };
      this.axios
        .post("/skinMgrSrv/article/finalSuggestionEdit", this.formData(data))
        .then(function (response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t("editsuccess"));
            _this.getList();
            _this.dialogEditVisible = false;
          } else {
            _this.$message(response.data.msg || _this.$i18n.t("editsfail"));
          }
        }).catch(function (res) {
          _this.doing = false;
          console.log(res);
          _this.$message(_this.$i18n.t("editsfail"));
        });
    },
    auditRecord(row) {
      this.auditRecordId = row.result_id;
      this.auditStatus = row.audit_status || 0;
      this.auditRemark = row.audit_remark || '';
      this.dialogAuditVisible = true;
    },
    saveAudit() {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {
        result_id: this.auditRecordId,
        checked_status: this.auditStatus,
        checked_mark: this.auditRemark
      };
      this.axios
        .post("/skinMgrSrv/countdown/saveAudit", this.formData(data))
        .then(function (response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t("editsuccess"));
            _this.getList();
            _this.dialogAuditVisible = false;
          } else {
            _this.$message(response.data.msg || _this.$i18n.t("editsfail"));
          }
        }).catch(function (res) {
          _this.doing = false;
          console.log(res);
        });
    },
    setCountdown(row) {
      this.countdownRecordId = row.result_id;
      this.countdownEndTime = (row.countdown_checked && row.countdown_checked.analysis_close_time) || '';
      this.countdownRow = row;
      if (!this.checkAuditStatus()) {
        return false;
      }
      if (!this.countdownEndTime) {
        this.$message(this.$i18n.t('record_list').please_select_countdown_time);
        return false;
      }
      this.dialogCountdownVisible = true;
    },
    checkAuditStatus() {
      if (this.countdownRow && this.countdownRow.countdown_checked) {
        const checkedStatus = this.countdownRow.countdown_checked.checked_status;
        if (checkedStatus !== 0 && checkedStatus !== undefined && checkedStatus !== null) {
          this.$message(this.$i18n.t('record_list').audited_cannot_operate);
          return false;
        }
      }
      return true;
    },
    // 将本地时间转换为 UTC-8 时间（北京时间）
    convertToUTC8(timeStr) {
      if (!timeStr) {
        return '';
      }
      // 解析时间字符串为 Date 对象（会被解析为本地时间）
      const localDate = new Date(timeStr.replace(/-/g, '/'));
      // 获取本地时区偏移（分钟）
      const localOffset = localDate.getTimezoneOffset();
      // UTC-8 是东八区，需要减去 8 小时（480 分钟）的偏移
      // 计算 UTC-8 时间：本地时间 - 本地偏移 + 8小时偏移
      const utc8Time = new Date(localDate.getTime() - localOffset * 60 * 1000 + 8 * 60 * 60 * 1000);
      
      // 格式化为 yyyy-MM-dd HH:mm:ss
      const year = utc8Time.getUTCFullYear();
      const month = String(utc8Time.getUTCMonth() + 1).padStart(2, '0');
      const day = String(utc8Time.getUTCDate()).padStart(2, '0');
      const hours = String(utc8Time.getUTCHours()).padStart(2, '0');
      const minutes = String(utc8Time.getUTCMinutes()).padStart(2, '0');
      const seconds = String(utc8Time.getUTCSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    extendCountdown() {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      // 将时间转换为 UTC-8 时间再提交
      const utc8Time = this.convertToUTC8(this.countdownEndTime);
      let data = {
        result_id: this.countdownRecordId,
        analysis_close_time: utc8Time,
        count_down_status: 2
      };
      this.axios
        .post("/skinMgrSrv/countdown/saveAudit", this.formData(data))
        .then(function (response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t("editsuccess"));
            _this.getList();
            _this.dialogCountdownVisible = false;
          } else {
            _this.$message(response.data.msg || _this.$i18n.t("editsfail"));
          }
        }).catch(function (res) {
          _this.doing = false;
          console.log(res);
        });
    },
    stopCountdown() {
      if (!this.checkAuditStatus()) {
        return false;
      }
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {
        result_id: this.countdownRecordId,
        count_down_status: 1
      };
      this.axios
        .post("/skinMgrSrv/countdown/saveAudit", this.formData(data))
        .then(function (response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t("editsuccess"));
            _this.getList();
            _this.dialogCountdownVisible = false;
          } else {
            _this.$message(response.data.msg || _this.$i18n.t("editsfail"));
          }
        }).catch(function (res) {
          _this.doing = false;
          console.log(res);
        });
    },
    shouldShowAuditFeatures(row) {
      // 基础条件：平台和功能开关
      if (this.platform !== 'leshen' || this.reportCountdown === false) {
        return false;
      }
      // 如果传入了行数据，检查审核状态：只有待审核状态（checked_status === 0）才显示按钮
      if (row && row.countdown_checked) {
        const checkedStatus = row.countdown_checked.checked_status;
        // checked_status: 0=待审核, 1=审核通过, 2=审核不通过
        // 只有待审核状态才显示按钮
        return checkedStatus === 0;
      }
      // 如果没有行数据，只检查基础条件（用于列显示）
      return true;
    }
  }
};
</script>
<style lang="scss">
#record {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }

    .el-card {
      cursor: pointer;
    }

    .el-card:hover {
      border: $blue 1px solid;
    }
  }

  .el-checkbox {
    margin-right: 5px;
    margin-top: 5px;
    width: 35px;
    text-align: center;
    font-size: 12px;
  }

  .el-dialog__body {
    padding: 5px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }

  .el-dialog__header {
    border-bottom: #e9e9e9 1px solid !important;
  }

  .el-button--mini,
  .el-button--mini.is-round {
    padding: 7px 0.0833rem;
  }

  .el-dialog__wrapper {
    top: -1.3rem;
  }

  .mark {
    top: 0rem;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border: none;
    color: #666;
    border-bottom: 1px solid #ccc;
    border-radius: 0px;
  }
}

.el-dialog__wrapper {
  top: -1.3rem;
}

.el-dialog {
  width: 940px;
}

.mark .el-dialog {
  width: 3.5rem;
}

.mark {
  top: 0rem;
}

iframe {
  .layout-content {
    overflow: hidden;
    overflow-y: hidden;
  }
}
</style>

<style scoped lang="scss">
#record {
  box-sizing: border-box;

  .rightContent {
    width: calc(100% - 0.32rem);
    height: calc(100% - 0.1667rem);
    display: inline-block;
    background-color: #fff;
    float: right;
    margin-right: 0.1667rem;
    margin-top: 0.1667rem;
    border-radius: 0.05rem;

    .tableheader {
      margin: 0.16rem;
    }

    p.title {
      height: 0.4167rem;
      line-height: 0.4167rem;
      font-size: 0.15rem;
      color: #000;
    }

    .btn2,
    .btn3 {
      padding: 0.0667rem 0.0833rem;
    }

    .codeshearch {
      width: 1.667rem;
    }

    .btn3,
    .codeshearch {
      float: right;
    }

    .listBlock {
      margin: 0.08rem;
      width: 100%;
      overflow-x: auto;
    }
    
    .listBlock .el-table {
      width: 100%;
      min-width: 1500px;
    }
    
    .listBlock .el-table__body-wrapper {
      overflow-x: auto;
    }

    .warncolor {
      color: red;
    }

    .btndel {
      margin-left: 0.1rem;
      height: 0.25rem;
      position: relative;
      top: 0.02rem;
      line-height: 100%;
      background-color: #57AEC9;
      border: 1px solid #57AEC9;
      color: #fff;
      padding: 8px 20px;
    }
  }

  .btnPrint {
    height: 0.28rem;
    position: relative;
    line-height: 0.28rem;
    background-color: #57AEC9;
    border: 1px solid #57AEC9;
    color: #fff;
    font-size: 0.15rem;
    padding: 0.01rem 0.2rem;
    margin-bottom: 0.05rem;
    margin-top: 0.05rem;
    float: right;
  }

  .question {
    width: calc(100% - 0.6rem);
    margin-top: 0.05rem;
    margin-left: 0.3rem;
  }

  .question .title {
    font-size: 0.17rem;
    color: #000000;
    font-weight: bold;
  }

  .question .check1 {
    color: #000000;
    display: block;
    margin-top: 0.05rem;
    width: 95%;
  }

  .question p {
    font-size: 0.09rem;
    color: #000000;
    display: inline-block;
    width: 80%;
    margin-left: 0.02rem;
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: top;
  }

  .question .check2 {
    color: #000000;
    display: inline-block;
    margin-top: 0.05rem;
    width: 31%;
  }

  .question label span {
    border: 0.01rem solid #aeaeae;
    width: 0.12rem;
    height: 0.12rem;
    border-radius: 50%;
    display: inline-block;
    margin-top: 0.02rem;
  }

  .question label i {
    width: 0.12rem;
    height: 0.12rem;
    border-radius: 50%;
    display: inline-block;
    position: absolute;
  }

  .question label .choose {
    border: 0.01rem solid #ffffff;
    width: 0.12rem;
    height: 0.12rem;
    border-radius: 50%;
    display: inline-block;
    margin-top: 0.02rem;
  }

  .question label .choose i {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACTklEQVRIS72WS2gTURSGvzPpS0tVqlCtQSkUrRQU3BTThQs3iqC4UfHZLHRhKy2iuJJ0FiouLEpjEV1UbFEXig/QrAQXpqggqOALxCDELqQupEoTTefIzDQhafPGONt77v/dc85/zx0hz6cdAS+GsR3YilhrwVjihlsTqPEGeIhl3ZfnZjSXjGRb0M5AM2r0g/qBqnyHABIgw4jVL2FzfHbsHIB2BrahjII0FBCetayTCPskbD5IX8gAqM88iuoFBKM08ZloxUKkT8YCg8n9KYBzckvuli2eVLQhhu5IZuIA3JrzofSy5MrTKVeb3RMX4DOvgB4qqyz2prpqiCdANU1CrspY4LA4VvRIpAi3ZOd7G2GoCyIT0Hs9PSbBtLaIbjC7EQ2WdfqmBTDkh6WLYOQpXH6cKaPSYwMeIbqlZEBjPVzyw4rFcOcFDITmSqiERH2BKMjykgANdRDsgtYmCL2G0/cgvfwpMf0q6jNjoLUZgL7N0LYMTtyEyVgme14NXNwP7V548g5O3QYrqzog8eyAMzth4xp4G4XeEZj67UJqquD8HljfAs8+wclbkJjOk7wDyFKiag+c2w0drfAyAsdvgGXB2V3gWwWvvsCxUdeaeT+7RLmabHt7YC+sWwnhjxBLwKZ2eD/u2vFXvHDbnCbns2l9LQwegNXNrtjnb9BzDX5MFRZ3brBt00IXbeF8CB50639kGL7/LE7cHuP2RStqVNR4wDAg9qdYcdtB7qj4L8NuBlK5cZ3Mu6IPTgpSySczDVK5Rz/dJv/it+UvGn7+fbORjSAAAAAASUVORK5CYII=);
    background-position: center;
    background-size: cover;
    display: inline-block;
    width: 0.13rem;
    height: 0.13rem;
    border-radius: 50%;
    position: absolute;
  }

  .line {
    background-color: #d8d8d8;
    width: 90%;
    height: 0.01rem;
    margin-top: 0.2rem;
    margin-left: auto;
    margin-right: auto;
  }

  .question .input-text {
    -webkit-appearance: none;
    background-color: #f2f2f2;
    border: none;
    color: #000000;
    display: inline-block;
    height: 0.4rem;
    line-height: 0.4rem;
    outline: 0;
    width: calc(90%);
    font-size: 0.18rem;
    padding-left: 0.23rem;
    margin-top: 0.1rem;
  }

  .question .input-submit {
    border-radius: 0.18rem;
    height: 0.36rem;
    width: 100%;
    font-size: 0.17rem;
    color: black;
    margin-top: 0.3rem;
    margin-bottom: 0.4rem;
    background: #ff3a80;
    color: #ffffff;
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/records/list.vue